import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { useSelector } from "react-redux";

const Tabwishkey = ({ toggleState }) => {
  const products = useSelector((state) => state?.product);
  const [selected, setSelected] = useState();
  useEffect(() => {
    setSelected(
      products?.filter((item, index) => item?.category === toggleState)
    );
    console.log("holaki", selected);
  }, [toggleState, products]);

  console.log("doonedoe", selected);

  return (
    <div className="Ourproduct">
      <div className="Tabwishkey">
        <div className="container">
          <div className="row">
            {selected?.map((item, index) => (
              <div className="col-md-3" key={index}>
                <ProductCard item={item} />
              </div>
            ))}
            {/* <div className="col-md-3">
              <ProductCard />
            </div>
            <div className="col-md-3">
              <ProductCard />
            </div>
            <div className="col-md-3">
              <ProductCard />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tabwishkey;
